module.exports = __webpack_public_path__ + "static/media/IMG_0774.0e7d75fc.jpg";